export const privacyContent = `
<div class="space-y-8">
  <!-- 1. 우리는 누구입니까? -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">우리는 누구입니까?</h2>
    <p class="text-gray-300 leading-relaxed">
      우리는 <strong>OXO Play</strong>(“<em>OXO Play</em>”, “<em>당사</em>”, “<em>우리</em>”)입니다. 당사는 웹 기반 게임을 쉽고 편리하게 즐길 수 있는 온라인 게임 플랫폼(이하 “<em>플랫폼</em>”)을 제공합니다. 사용자는 계정을 등록(이하 “<em>계정</em>”)하거나 등록하지 않은 상태로도 플랫폼을 이용할 수 있습니다. 플랫폼은 지역에 따라 달라질 수 있는 당사의 공식 웹사이트(이하 “<em>웹사이트</em>”)를 통해 접속하실 수 있습니다.
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      당사는 귀하가 우리에게 부여하는 신뢰의 중요성을 잘 알고 있으며, 귀하의 개인정보 보호를 매우 중요하게 생각합니다. 본 개인정보처리방침(이하 “<em>본 방침</em>”)은 귀하가 플랫폼을 이용할 때 당사가 개인정보를 어떻게 수집, 처리, 공개, 보관 및 보호하는지에 대한 설명을 담고 있습니다. 본 방침을 숙지하시어 귀하의 권리와 당사의 의무를 이해하시기 바랍니다.
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      본 플랫폼은 원칙적으로 만 13세 이상(또는 귀하가 거주하는 국가에서 요구하는 최소 연령 이상)의 사용자에게 제공됩니다. 만약 귀하가 만 13세 미만(또는 거주 국가의 해당 최소 연령 미만)이라면 플랫폼을 이용하지 않길 부탁드립니다. 당사는 해당 연령 미만의 사용자로부터 고의로 개인정보를 수집하지 않습니다.
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      당사의 이용약관(Terms of Service)에 대한 자세한 내용은 별도로 확인해 주시기 바랍니다.
    </p>
  </section>

  <!-- 2. 개인정보란 무엇입니까? -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">개인정보란 무엇입니까?</h2>
    <p class="text-gray-300 leading-relaxed">
      “<strong>개인정보</strong>”란, 직·간접적으로 귀하를 식별할 수 있는 정보입니다. 예를 들어, 귀하의 이름이나 이메일 주소 등이 이에 해당합니다. 당사가 귀하의 플랫폼 계정과 연동하여 식별할 수 있다면, 귀하가 플레이한 게임 이력 등도 개인정보에 포함될 수 있습니다.
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      특히 멀티플레이 게임 등에서 실명을 사용하거나 개인정보를 공유하는 것은 가급적 삼가시길 권장드립니다.
    </p>
  </section>

  <!-- 3. 당사는 누구로부터 개인정보를 수집합니까? -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">당사는 누구로부터 개인정보를 수집합니까?</h2>
    <p class="text-gray-300 leading-relaxed">
      플랫폼 운영을 위해, 당사는 다음과 같은 출처로부터 데이터를 수집할 수 있습니다:
    </p>
    <ul class="list-disc list-inside mt-4 text-gray-300 space-y-2">
      <li>플랫폼 및 웹사이트의 방문자 및 사용자</li>
      <li>웹 게임 개발자</li>
      <li>연락처 정보(예: 이메일 등)를 직접 제공하는 개인</li>
      <li>이메일, 문의 티켓 등 다양한 경로로 당사에 연락하는 분들</li>
    </ul>
    <p class="text-gray-300 leading-relaxed mt-4">
      위에서 언급했듯이, 당사는 원칙적으로 만 13세 이상(또는 거주 국가의 최소 연령 이상) 사용자의 개인정보만을 수집합니다.
    </p>
  </section>

  <!-- 4. OXO Play는 어떠한 개인정보를 어떤 목적으로 처리합니까? -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">OXO Play는 어떠한 개인정보를 어떤 목적으로 처리합니까?</h2>
    <p class="text-gray-300 leading-relaxed">
      아래 표는 당사가 수집·처리하는 개인정보의 종류와 목적(“왜”) 및 법적 근거(“어떤 근거”)를 요약한 것입니다:
    </p>
    <div class="overflow-auto mt-4">
      <table class="min-w-full text-left text-gray-300 border-collapse">
        <thead>
          <tr>
            <th class="border-b py-2 pr-4 font-semibold">목적</th>
            <th class="border-b py-2 pr-4 font-semibold">수집되는 개인정보</th>
            <th class="border-b py-2 font-semibold">법적 근거</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              구직 지원 검토
            </td>
            <td class="border-b py-2 pr-4 align-top">
              이메일 주소, 이름, 나이, 성별, 이력서(CV)
            </td>
            <td class="border-b py-2 align-top">
              계약 이행 또는 계약 체결 전 사전조치를 위한 필요성
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              계정 등록 및 인증
            </td>
            <td class="border-b py-2 pr-4 align-top">
              이메일, 이름, 나이, 성별, 외부 계정 정보, 사용자명, 비밀번호
            </td>
            <td class="border-b py-2 align-top">
              이용자의 사전 명시적 동의
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              맞춤형 게임 경험 제공
            </td>
            <td class="border-b py-2 pr-4 align-top">
              사용자명, 기기/연결 정보, 관심사, 게임 이용 행태, 피드백
            </td>
            <td class="border-b py-2 align-top">
              이용자의 사전 명시적 동의
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              문의/불만사항 대응
            </td>
            <td class="border-b py-2 pr-4 align-top">
              이름, 이메일 주소, 기타 제공 정보
            </td>
            <td class="border-b py-2 align-top">
              플랫폼 품질 개선을 위한 정당한 이익
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              새로운 플랫폼 기능 안내
            </td>
            <td class="border-b py-2 pr-4 align-top">
              사용자명, 이메일 주소
            </td>
            <td class="border-b py-2 align-top">
              관련 정보를 제공하기 위한 정당한 이익
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              플랫폼 개선을 위한 이용 통계 분석
            </td>
            <td class="border-b py-2 pr-4 align-top">
              사용자 행동 데이터(사용/기기 정보), 게임 내 통계
            </td>
            <td class="border-b py-2 align-top">
              플랫폼 성능 및 사용자 경험을 이해하기 위한 정당한 이익
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              법적 의무 준수
            </td>
            <td class="border-b py-2 pr-4 align-top">
              관련 법령에서 요구되는 정보
            </td>
            <td class="border-b py-2 align-top">
              법적 의무 이행의 필요성
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              사기 및 불법 행위 예방
            </td>
            <td class="border-b py-2 pr-4 align-top">
              사기 또는 불법 행위를 탐지하기 위해 필요한 정보
            </td>
            <td class="border-b py-2 align-top">
              사기 및 불법 행위 방지를 위한 정당한 이익
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              마케팅 커뮤니케이션
            </td>
            <td class="border-b py-2 pr-4 align-top">
              사용자명, 이메일 주소
            </td>
            <td class="border-b py-2 align-top">
              이용자의 사전 명시적 동의
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              플랫폼 내 광고 지원
            </td>
            <td class="border-b py-2 pr-4 align-top">
              쿠키 등을 통한 수집 정보(IP, 사용자 식별자, 브라우저 유형 등)
            </td>
            <td class="border-b py-2 align-top">
              개인정보처리방침 및 쿠키 정책 동의 후, 광고 선호 설정에 대한 사전 명시적 동의
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              게임 개발자와의 계약 이행
            </td>
            <td class="border-b py-2 pr-4 align-top">
              이메일, 세금 식별 번호, 은행 계좌 정보, 결제 정보
            </td>
            <td class="border-b py-2 align-top">
              계약 이행의 필요성
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              인게임 결제 처리
            </td>
            <td class="border-b py-2 pr-4 align-top">
              결제 관련 정보(제3자 결제 서비스에서 처리)
            </td>
            <td class="border-b py-2 align-top">
              계약 이행의 필요성
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="text-gray-300 leading-relaxed mt-4">
      <strong>계정 등록:</strong> 계정을 등록하실 경우, 귀하는 비밀번호, 이메일, 사용자 에이전트(user agent), IP 주소 등의 정보를 당사에 제공하는 데 동의하게 됩니다. 당사는 페이스북, 구글 등 제3자 서비스를 통해 로그인을 지원할 수 있습니다. 이 경우 제3자 서비스가 귀하의 이름, 이메일 주소, 생년월일 등 정보를 당사와 공유하도록 허용하게 됩니다.
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      <strong>광고:</strong> 당사는 플랫폼 내에서 다양한 광고주로부터 광고를 게재할 수 있습니다. 이는 맞춤형 광고 또는 일반 광고일 수 있으며, 맞춤형 광고의 경우 귀하의 사전 동의가 필요하며, IP 주소나 광고 식별자 등의 일부 데이터가 제3자 광고업체와 공유될 수 있습니다. 쿠키 관리 도구 또는 브라우저 설정에서 광고 선호도를 조정할 수 있습니다.
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      <strong>프로파일링:</strong> 게임 통계(게임 내 성적 등)를 분석하여 맞춤형 게임을 추천할 수 있습니다. 이는 귀하에게 법적으로 중대한 영향을 미치는 자동화된 의사결정에 해당하지 않습니다. EEA 또는 영국 등 특정 지역에 거주 중이시라면, 귀하는 언제든 해당 프로파일링이나 직접 마케팅을 거부할 권리가 있을 수 있습니다.
    </p>
  </section>

  <!-- 5. 당사는 귀하의 개인정보를 다른 이들과 공유합니까? -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">당사는 귀하의 개인정보를 다른 이들과 공유합니까?</h2>
    <p class="text-gray-300 leading-relaxed">
      당사는 아래와 같은 대상과 개인정보를 공유할 수 있습니다:
    </p>
    <ul class="list-disc list-inside mt-4 text-gray-300 space-y-2">
      <li>
        <strong>서비스 제공 업체:</strong> IT 서비스, 결제 처리, 데이터 분석 등 당사 운영을 지원하는 제3자 업체
      </li>
      <li>
        <strong>다른 사용자:</strong> 귀하가 공개 또는 일부 공개 프로필을 선택한 경우(예: 사용자명, 게임 기록 등), 다른 사용자가 해당 정보를 볼 수 있습니다. 계정 설정에서 공개 범위를 조정할 수 있습니다.
      </li>
      <li>
        <strong>광고:</strong> 해시 처리된 이메일, IP 주소 등 익명·가명 처리된 정보를 광고 네트워크에 제공하여 개인맞춤형 광고를 게재할 수 있습니다. 이 경우에도 귀하의 사전 동의가 필요합니다.
      </li>
      <li>
        <strong>게임 개발자:</strong> 일부 게임은 외부 파트너가 개발합니다. 익명 처리된 이용 통계나, 인게임 결제와 관련된 일부 정보를 해당 개발자와 공유할 수 있습니다.
      </li>
      <li>
        <strong>결제 서비스:</strong> 인게임 결제를 진행할 경우, 결제는 제3자 결제 서비스 제공업체가 처리합니다. 당사는 결제 내역을 계정과 연결하지만, 전체 결제 정보 자체를 직접 수집하진 않습니다.
      </li>
      <li>
        <strong>국외 이전:</strong> 귀하의 데이터가 귀하의 관할권 밖으로 이전될 수 있으며, 이 경우 당사는 표준계약조항(Standard Contractual Clauses) 등 적절한 보호조치를 적용합니다.
      </li>
    </ul>
  </section>

  <!-- 6. 당사는 귀하의 개인정보를 얼마나 오래 보관합니까? -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">당사는 귀하의 개인정보를 얼마나 오래 보관합니까?</h2>
    <p class="text-gray-300 leading-relaxed">
      당사는 본 방침에 명시된 목적을 달성하기 위해 필요한 기간 동안만 개인정보를 보관합니다. 계정을 보유한 사용자의 경우 직접 계정 삭제를 요청하거나, 법률 및 사업상 필요 기간이 경과할 때까지 데이터를 보유할 수 있습니다. 계정 삭제는 되돌릴 수 없는 조치이므로, 삭제 후에는 계정 및 그에 연결된 정보에 접근할 수 없습니다.
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      또한 법적 의무 준수, 분쟁 해결, 사기 예방 등의 목적상 필요한 경우 더 오랜 기간 데이터를 보관할 수도 있습니다.
    </p>
  </section>

  <!-- 7. OXO Play는 귀하의 데이터를 안전하게 보호합니까? -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">OXO Play는 귀하의 데이터를 안전하게 보호합니까?</h2>
    <p class="text-gray-300 leading-relaxed">
      당사는 기술적·관리적 보안 조치를 통해 귀하의 개인정보를 분실, 도난, 무단 접근 등으로부터 보호하고자 노력합니다. 또한, 필요한 임직원 및 계약업체만 개인정보에 접근할 수 있도록 제한하고 있으며, 제3자 업체와 제휴 시에도 엄격한 데이터 보호 기준을 적용하도록 요구합니다.
    </p>
  </section>

  <!-- 8. 귀하는 자신의 개인정보에 대한 통제권을 가집니다 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">귀하는 자신의 개인정보에 대한 통제권을 가집니다</h2>
    <p class="text-gray-300 leading-relaxed">
      거주 지역의 법률에 따라, 귀하는 다음과 같은 권리를 행사할 수 있습니다:
    </p>
    <ul class="list-disc list-inside mt-4 text-gray-300 space-y-2">
      <li><strong>열람 및 사본 발급:</strong> 당사가 보유 중인 귀하의 개인정보를 열람하거나 사본을 요청할 수 있습니다.</li>
      <li><strong>정정:</strong> 귀하의 개인정보가 부정확하거나 변경된 경우 이를 수정할 수 있습니다.</li>
      <li><strong>삭제(잊혀질 권리):</strong> 보유 근거가 없는 개인정보의 삭제를 요청할 수 있습니다.</li>
      <li><strong>처리 제한:</strong> 일정 요건에 해당하는 경우 개인정보 처리 제한을 요구할 수 있습니다.</li>
      <li><strong>동의 철회:</strong> 이전에 제공한 동의를 언제든지 철회할 수 있습니다.</li>
      <li><strong>마케팅/프로파일링 거부:</strong> 직접 마케팅 및 프로파일링에 대한 처리를 거부할 수 있습니다.</li>
      <li><strong>데이터 이동권:</strong> 구조적·일반적·기계 판독이 가능한 형식으로 본인 정보를 요청할 수 있습니다.</li>
      <li><strong>차별 금지:</strong> 위 권리 행사를 이유로 차별받지 않습니다.</li>
    </ul>
    <p class="text-gray-300 leading-relaxed mt-4">
      위 권리를 행사하고자 하실 경우, 웹사이트에 안내된 방법(예: 문의 양식, 이메일 등)을 통해 연락해 주시기 바랍니다. 당사는 합리적인 기간 내에, 관련 법률에 따라 조치를 취하며, 필요한 경우 신분 증명을 요청드릴 수 있습니다.
    </p>
  </section>

  <!-- 9. 광고 환경설정을 관리하기 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">광고 환경설정을 관리하기</h2>
    <p class="text-gray-300 leading-relaxed">
      처음 웹사이트에 접속할 때, 당사의 동의 관리 플랫폼(Consent Management Platform, CMP)을 통해 쿠키 설정을 수락·거부할 수 있습니다. 계정 설정 또는 “Preferences” 링크를 통해 언제든지 광고 선호도를 변경할 수 있습니다. 브라우저 설정에서 쿠키를 차단할 수도 있지만, 이 경우 플랫폼의 일부 기능 이용에 제약이 있을 수 있습니다.
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      온라인 맞춤형 광고 및 선택권에 대한 자세한 내용은 관련 광고 기관 또는 단체에서 제공하는 자료를 참고하시기 바랍니다.
    </p>
  </section>

  <!-- 10. 아동의 개인정보 보호 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">아동의 개인정보 보호</h2>
    <p class="text-gray-300 leading-relaxed">
      본 플랫폼은 만 13세 이상(또는 국가별 법령 상 최소 연령 이상) 사용자만 이용 가능합니다. 당사는 13세 미만 아동의 개인정보를 고의로 수집하지 않습니다. 만약 당사가 해당 아동으로부터 개인정보를 수집했다는 사실을 인지하시는 경우, 즉시 연락해 주시면 빠른 시일 내에 해당 정보를 삭제하겠습니다.
    </p>
  </section>

  <!-- 11. 다른 웹사이트로의 링크 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">다른 웹사이트로의 링크</h2>
    <p class="text-gray-300 leading-relaxed">
      당사의 플랫폼 또는 일부 게임에는 당사가 운영하지 않는 외부 사이트로 연결되는 링크가 포함될 수 있습니다. 당사는 이러한 제3자 웹사이트나 서비스의 개인정보 처리방침에 대해 책임을 지지 않으므로, 해당 사이트 이용 시 해당 사이트의 방침을 참고하시기 바랍니다.
    </p>
  </section>

  <!-- 12. 외부에서 호스팅되는 게임 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">외부에서 호스팅되는 게임</h2>
    <p class="text-gray-300 leading-relaxed">
      본 방침은 OXO Play가 직접 통제하지 않는 외부 게임 개발자나 호스팅 회사가 운영하는 게임에는 적용되지 않습니다. 당사는 해당 개발자에게 관련 법령 준수를 요구하지만, 게임을 플레이하기 전 해당 개발자의 개인정보 처리방침을 확인하시는 것을 권장드립니다.
    </p>
  </section>

  <!-- 13. 미국 이용자의 개인정보 권리 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">미국 이용자의 개인정보 권리</h2>
    <p class="text-gray-300 leading-relaxed">
      일부 미국 주(州)의 법률에 따라, 개인정보의 접근·삭제·판매 또는 공유 거부 등 특정 권리가 부여될 수 있습니다. 당사는 해당 법률이 적용되는 경우 이를 준수하며, 관련 요청이 있을 시 적극 협조합니다.
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      당사는 귀하가 이러한 권리를 행사한다는 이유로 차별하지 않습니다.
    </p>
  </section>

  <!-- 14. 개인정보처리방침 변경 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">개인정보처리방침 변경</h2>
    <p class="text-gray-300 leading-relaxed">
      당사는 수시로 본 방침을 업데이트할 수 있으며, 문서 상단에 “최종 업데이트” 일자를 표기합니다. 중요한 변경 사항이 있을 경우 플랫폼 내 공지 또는 이메일 등을 통해 안내드릴 수 있습니다. 변경된 방침이 적용된 이후에도 플랫폼을 계속 이용하시면, 귀하는 변경 사항에 동의하는 것으로 간주됩니다.
    </p>
  </section>

  <!-- 15. 개인정보 관련 추가 문의사항 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">개인정보 관련 추가 문의사항</h2>
    <p class="text-gray-300 leading-relaxed">
      본 개인정보처리방침 또는 당사의 개인정보 처리에 대해 궁금한 점이 있으시면,
      <a href="/contact" class="underline hover:no-underline">Contact Us</a>
      페이지 또는 안내된 이메일 주소를 통해 문의해 주시기 바랍니다. 당사가 귀하의 문의를 충분히 해결하지 못했다고 판단되시면, 해당 지역의 개인정보 감독 기관에 민원을 제기하실 권리가 있습니다.
    </p>
  </section>
</div>
`; 